import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import SiteEntry from "@/components/SiteEntry";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AcceptInvite from "@/pages/AcceptInvite";
import ResetPassword from "@/pages/ResetPassword";
import TakeawaySuccess from "@/pages/TakeawaySuccess";
import TakeawayCancel from "@/pages/TakeawayCancel";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<SiteEntry />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/invite" element={<AcceptInvite />} />
            <Route path="/admin/reset" element={<ResetPassword />} />
            <Route path="/takeaway/success" element={<TakeawaySuccess />} />
            <Route path="/takeaway/cancel" element={<TakeawayCancel />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" toastOptions={{ className: "font-mono-plex" }} />
      </AuthProvider>
    </div>
  );
}

export default App;
